import React, { useState, useEffect, useContext } from "react"
import { Link } from "gatsby"
import { Helmet } from "react-helmet"
import axios from "axios"

import SEO from "../components/SEO"
import Heading from "../components/Heading"
import CheckoutBtn from "../components/CheckoutBtn"
import Button from "../components/Button"
import Image from "../components/Image"
import CartUpsell from"../components/CartUpsell"

import { AppContext } from "../components/Context"

import styles from "./cart.module.scss"

import cart from "../helpers/cart"
import Price from "../components/Price"

const Cart = ({ location }) => {
  const appState = useContext(AppContext)

  const [cartItems, setCartItems] = useState(cart.getCart())

  const cartCount = appState.cartCount = cart.getCartCount()
  const subtotal = cartItems.reduce((acc, item) => (acc + parseInt(item.price, 10) * item.quantity), 0)

  const tm_loop = (typeof sessionStorage !== "undefined") ?
    JSON.parse(sessionStorage.getItem("tm_loop"))
    : null
  const [loopCartToken, setLoopCartToken] = useState(null)

  const updateLoopCart = () => {
    // Update cart with Loop
    axios({
      url: `https://api.loopreturns.com/api/v1/cart/${loopCartToken}`,
      method: "post",
      headers: {
        "content-type": "application/json",
        "x-authorization": "d963096ec50ae7419104a54ce1ac5a56bc84106b", // API key
      },
      data: {
        "cart": cartItems.map(item => item.variantId),
      },
    })
      .then(response => {
        // console.log(response)
      })
  }

  // Loop On Store experience is active
  useEffect(() => {
    if (tm_loop && tm_loop.active === "true" && !loopCartToken)
      // Create cart with Loop
      axios({
        url: "https://api.loopreturns.com/api/v1/cart/",
        method: "post",
        headers: {
          "content-type": "application/json",
          "x-authorization": "d963096ec50ae7419104a54ce1ac5a56bc84106b", // API key
        },
        data: {
          "cart": cartItems.map(item => item.variantId),
        },
      })
        .then(response => {
          // console.log(response)
          setLoopCartToken(response.data.token)
        })
  }, [tm_loop, cartItems, loopCartToken])

  return (
    <>
      <SEO
        title="Cart Page"
        description={`Put description here`}
        url={location.href}
      />

      <Heading
        tag="h1"
        level="0"
        className={styles.heading}
      >
        Cart
      </Heading>

      <section className={styles.module}>
        {cartItems && cartItems.length > 0 &&
          <div>
            <ul className={styles.cart}>
              {cartItems.map((item, i) => (
                <CartItem
                  key={i}
                  item={item}
                  setCartItems={setCartItems}
                  updateLoopCart={updateLoopCart}
                />
              ))}
            </ul>
            <div className={styles.subtotalContainer}>
              <h4>Subtotal for {cartCount} {cartCount === 1 ? "item" : "items"}:</h4>
              <p className={styles.subtotalAmount}>${parseInt(subtotal, 10).toLocaleString()}.00</p>
              <CheckoutBtn
                className={styles.checkoutButton}
                loopCartToken={loopCartToken}
              />
              <p className={styles.affirm}>Monthly payments available with 0% APR with Affirm.</p>
            </div>
            <CartUpsell
              setCartItems={setCartItems}
            />
          </div>
        }
        {cartItems && cartItems.length <= 0 &&
          <div className={styles.empty}>
            <p>Your cart is empty. Like your closet, it’ll look prettier with some new shoes in it.</p>
            <Button
              url="/collections/all"
            >
              Shop All
            </Button>
          </div>
        }
      </section>

      <Helmet>
        <script>{`
          var criteo_items = [];
          ${cartItems.forEach(item => (
            `criteo_items.push({
              id : "${item.productId}",
              price : ${item.price},
              quantity : ${item.quantity}
            });`
          ))}
          window.criteo_q = window.criteo_q || [];
          window.criteo_q.push(
            { event: "viewBasket", ecpplugin: "shopify", product: criteo_items}
          );
        `}</script>
      </Helmet>
    </>
  )
}

export default Cart

const CartItem = ({ item, setCartItems, tm_loop, updateLoopCart }) => {
  const appState = useContext(AppContext)
  const [quantity, setQuantity] = useState(item.quantity)

  const updateCartCount = () => {
    appState.set({
      cartCount: cart.getCartCount(),
    })
  }

  const decrementQuantity = (e, amount = 1) => {
    if (quantity > 1) {
      cart.decrementQuantity(item, amount)
      setQuantity(quantity - 1)
    } else
      cart.removeItem(item)
    setCartItems(cart.getCart())
    updateCartCount()
  }

  const incrementQuantity = (e, amount = 1) => {
    if (quantity < item.maxQuantity) {
      cart.incrementQuantity(item, amount)
      setQuantity(quantity + 1)
      setCartItems(cart.getCart())
      updateCartCount()
    }
  }

  const changeQuantity = e => {
    if (e.target.value === "")
      return
    const value = parseInt(e.target.value, 10)
    if (value === 0)
      cart.removeItem(item)
    else if (value > item.maxQuantity)
      setQuantity(item.maxQuantity)
    else {
      if (value > quantity)
        cart.incrementQuantity(item, value - quantity)
      if (value < quantity)
        cart.decrementQuantity(item, quantity - value)
      setQuantity(value)
    }
    setCartItems(cart.getCart())
    updateCartCount()
  }

  const removeItem = () => {
    cart.removeItem(item)
    setCartItems(cart.getCart())
    updateCartCount()
    if (tm_loop && tm_loop.active === "true")
      updateLoopCart()
  }

  return (
    <li className={styles.item}>
      <Link
        to={`${item.url}${(item.url.includes("?")) ? "&" : "?"}origin=cart`}
        className={styles.imageLink}
      >
        <Image
          image={item.image}
          className={styles.image}
        />
      </Link>
      <div className={styles.content}>
        <h2 className={styles.title}>
          <Link to={item.url}>{item.title}</Link>
        </h2>

        <div className={styles.info}>
          {item.size ?
            <p className={styles.details}>{item.color} / {item.size}</p>
            :
            <p className={styles.details} />
          }
          <p className={styles.price}>
            <Price
              price={(quantity * parseInt(item.price, 10))}
              compareAtPrice={(item.compareAtPrice) ?
                (quantity * parseInt(item.compareAtPrice, 10))
                : null
              }
            />
          </p>
        </div>

        <div className={styles.quantityContainer}>
          <button
            className={styles.minus}
            onClick={decrementQuantity}
          >
            −
          </button>
          <input type="number"
                 className={styles.quantity}
                 value={quantity}
                 min="1"
                 pattern="[0-9]*"
                 onChange={changeQuantity}
          />
          <button
            className={styles.plus}
            onClick={incrementQuantity}
          >
            +
          </button>
          <button
            className={styles.remove}
            onClick={removeItem}
          >
            Remove
          </button>
        </div>

        {item.dateExpected &&
          <p className={styles.presaleNote}>Estimated to ship {new Date(item.dateExpected).toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" })}</p>
        }

        {item.isGwp &&
          <p className={styles.gwp}>Promotion will be applied at checkout.</p>
        }
      </div>
    </li>
  )
}
